import { currencyCodes } from 'constants/currency';

const getCurrencySymbol = (currencyCode) => {
  return currencyCodes[currencyCode] || currencyCode;
};

export default getCurrencySymbol;
